import { AccountSwitcher } from './AccountSwitcher';
export default AccountSwitcher;
